import React from 'react'
import { FilterType, PopoverFilter, PopoverFilterType } from '~/components/shared'
import { EHealthProceduresTypes } from '~/interfaces'

interface Option {
  text: string
  type: EHealthProceduresTypes[]
}

interface MedicalEventTypeFilterProps {
  isActive: boolean
  selected: string[]
  options: Option[]
  onChange: (newTypes: FilterType[]) => void
}

export const MedicalEventTypeFilter = ({
  selected,
  options,
  isActive,
  onChange
}: MedicalEventTypeFilterProps): JSX.Element => {
  return (
    <PopoverFilter active={isActive} svgFilled iconName="pageInfo" tooltipDescription="Legenda e Filtros">
      <PopoverFilterType checkedTypes={selected} filterTypes={options} setTypes={onChange} />
    </PopoverFilter>
  )
}
